/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chain_Page_Compare_Metric_DevelopersInputs */



/**
* | output |
* | --- |
* | "developers" |
*
* @param {Chain_Page_Compare_Metric_DevelopersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_metric_developers = /** @type {((inputs?: Chain_Page_Compare_Metric_DevelopersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Metric_DevelopersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("developers")
});